import { Component, OnDestroy, OnInit, ViewChild, ViewContainerRef } from '@angular/core';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { GlobalErrorHandlerService } from '@app/core/services';
import { DialogService } from '@progress/kendo-angular-dialog';
import { AuthenticatorSetupComponent } from '@app/shared/components/authenticator-setup/authenticator-setup.component';
import { MFAService } from '@app/core/http-services/mfa.service';
import { UserService } from '@app/core/http-services/user.service';
import { TokenService } from '@app/shared/services/token.service';
import { AuthService as Auth0Service } from '@auth0/auth0-angular';
import { environment } from '@env/environment';
@Component({
  selector: 'app-security-setup',
  templateUrl: './security-setup.component.html',
  styleUrls: ['./security-setup.component.scss'],
})
export class SecuritySetupComponent implements OnInit, OnDestroy {
  destroy$: Subject<boolean> = new Subject<boolean>();
  @ViewChild('container', { read: ViewContainerRef })
  public container: ViewContainerRef;
  userDetails: any;
  loader: boolean = false;
  securityBreadcrumbs: any = [
    {
      label: 'Security',
      active: true,
    },
  ];
  isOtpSet: boolean = false;
  isGuardianSet: boolean = false;
  isPhoneSet: boolean = false;
  isEmailSet: boolean = false;
  constructor(
    private userService: UserService,
    private errorHandler: GlobalErrorHandlerService,
    private mfaService: MFAService,
    private dialogService: DialogService,
    private tokenService: TokenService,
    private auth0Service: Auth0Service
  ) {}
  async ngOnInit() {
    this.userDetails = await this.userService.getUserDetails();
    if (this.tokenService.checkSuperAdmin()) {
      this.getEnrolledAuthenticators();
    }
  }

  ngOnDestroy() {
    this.destroy$.next(true);
    this.destroy$.complete();
  }
  /**
   * Open authenticator modal
   */
  setupGoogleAuthenticator(mode) {
    this.auth0Service
      .loginWithPopup({
        authorizationParams: {
          audience: `https://${environment.auth.auth_domain}/mfa/`,
          scope:
            'openid profile email sso:admin_all enroll read:authenticators remove:authenticators',
        },
      })
      .subscribe(() => {
        const dialog = this.dialogService.open({
          content: AuthenticatorSetupComponent,
          cssClass: `ces-modal-popup ces-modal-popup-md `,
          appendTo: this.container,
        });
        const catInfo = dialog.content.instance;
        catInfo.cancelBtnText = 'Cancel';
        catInfo.confirmBtnText = 'Add New App';
        catInfo.confirmType = 'success';
        catInfo.appDetails = { ...this.userDetails, mode: mode };

        dialog.result.subscribe((result: any) => {
          if (result?.isSuccess) {
            this.getEnrolledAuthenticators();
          }
        });
      });
  }

  /**
   * Get user's enrolled mfa authenticators
   */
  getEnrolledAuthenticators() {
    this.loader = true;
    this.mfaService
      .getEnrolledAuthApi(this.userDetails?.sub)
      .pipe(takeUntil(this.destroy$))
      .subscribe(
        (response: any) => {
          if (response.length) {
            response.forEach((element) => {
              if (element.type == 'totp' && element.confirmed) {
                this.isOtpSet = true;
              }
              if (element.type == 'guardian' && element.confirmed) {
                this.isGuardianSet = true;
              }
              if (element.type == 'phone' && element.confirmed) {
                this.isPhoneSet = true;
              }
              if (element.type == 'email' && element.confirmed) {
                this.isEmailSet = true;
              }
            });
          }
          this.loader = false;
        },
        (err) => {
          this.loader = false;
          this.errorHandler.apiErrorHandle(err);
        }
      );
  }
}
